"use strict";

module.exports = Object.assign(
	{
		BasicLegend: require('./lib/legend'),
		BasicChart: require('./charts/basic'),
		format: require('./lib/format'),
		mix: require('./lib/mix')
	},
	require('./lib/axis'),
	require('./charts/dates'),
	require('./charts/layered'),
	{
		StackedBarsChart: require('./charts/stacked-bars'),
		LayeredLinesChart: require('./charts/layered-lines')
	}
);